import { LuClipboard } from 'react-icons/lu';

import { logger, useClipboard } from '@/utils';

import { Toast } from '../widgets/Toast';
import { DropdownMenuItem } from './ui/dropdown-menu';

export const useCopyGuid = (guid: string) => {
    const { copy } = useClipboard({
        timeoutMs: 1000,
        onError: (error) => {
            logger.error('Failed to copy text:', error);
            Toast.error('Failed to copy GUID', 'error');
        },
    });

    const copyGuid = async () => {
        await copy(guid);
        Toast.success('GUID copied to clipboard');
    };

    return { copyGuid, copyGuidLabel: `Copy GUID (${guid.slice(0, 4)}...)` };
};

interface CopyGuidDropdownMenuItemProps {
    guid: string;
    label?: string;
}

export const CopyGuidDropdownMenuItem = (props: CopyGuidDropdownMenuItemProps) => {
    const { copyGuid, copyGuidLabel } = useCopyGuid(props.guid);
    return (
        <DropdownMenuItem onClick={copyGuid} className="flex w-full items-center gap-2">
            <span>
                <LuClipboard className="h-4 w-4" />
            </span>
            <span>{props?.label ?? copyGuidLabel}</span>
        </DropdownMenuItem>
    );
};
